'use client';

import CandidateStore from './CandidateStore/CandidateStore';
import AdminStore from './AdminStore/AdminStore';
import ElectionMenuStore from './ElectionMenuStore/ElectionMenuStore';
import TabStore from './TabStore/TabStore';
import LoginPageStore from './LoginPageStore/LoginPageStore';
import MessageModalStore from './MessageModalStore/MessageModalStore';
import LoadingOverlayStore from './LoadingOverlayStore/LoadingOverlayStore';
import RegionPreviewStore from './RegionPreviewStore/RegionPreviewStore';
import RegionStore from './RegionStore/RegionStore';
import UserStore from './UserStore/UserStore';
import GeneralSettingsStore from './GeneralSettingsStore/GeneralSettingsStore';
import CompanyStore from './Company/CompanyStore';
import StandAdminStore from './StandAdminStore/StandAdminStore';
import ZipcodeStore from './ZipcodeStore/ZipcodeStore';
import ReportStore from './ReportStore/ReportStore';
import AdminReportStore from './AdminReportStore/AdminReportStore';

export default class AppStore {
    tabStore = new TabStore();
    candidateStore = new CandidateStore();
    adminStore = new AdminStore();
    electionMenuStore = new ElectionMenuStore();
    loginPageStore = new LoginPageStore();
    messageModalStore = new MessageModalStore();
    loadingOverlayStore = new LoadingOverlayStore();
    regionPreviewStore = new RegionPreviewStore();
    regionStore = new RegionStore();
    userStore = new UserStore();
    generalSettingsStore = new GeneralSettingsStore();
    standAdminStore = new StandAdminStore();
    zipcodeStore = new ZipcodeStore();
    companyStore = new CompanyStore();
    reportStore = new ReportStore();
    adminReportStore = new AdminReportStore();

    resetAllStoreData = () => {
        this.tabStore.resetToDefault();
        this.candidateStore.resetToDefault();
        this.adminStore.resetToDefault();
        this.loginPageStore.resetToDefault();
        this.userStore.resetToDefault();
        this.messageModalStore.resetToDefault();
        this.loadingOverlayStore.resetToDefault();
        this.regionStore.resetToDefault();
        this.userStore.resetToDefault();
        this.generalSettingsStore.resetToDefault();
        this.standAdminStore.resetToDefault();
        this.companyStore.resetToDefault();
        this.companyStore.resetToDefault();
        this.standAdminStore.resetToDefault();
        this.zipcodeStore.resetToDefault();
        this.reportStore.resetToDefault();
        this.adminReportStore.resetToDefault();
    };
}

let store: AppStore;

function initializeStore() {
    const _store = new AppStore();

    store = _store;

    return store;
}

// This getStore can be mocked in unit test expected to test with store easier
function getStore() {
    if (!store) {
        initializeStore();
    }
    return store;
}

export { getStore };
